/**
 * Nomes dos eventos de Socket.IO. Entram em uso na Fase 3;
 * ficam registrados aqui desde já para não nascerem espalhados.
 */
export const EVENTOS = {
  mensagemNova: 'mensagem:nova',
  mensagemAtualizada: 'mensagem:atualizada',
  chamadoAtualizado: 'chamado:atualizado',
  chamadoTransferido: 'chamado:transferido',
  conexaoStatus: 'conexao:status',
  conexaoQrcode: 'conexao:qrcode',
  notificacaoNova: 'notificacao:nova',
  usuarioStatus: 'usuario:status',
  /** O servidor recusou a entrada na sala de um número não liberado. */
  acessoNegado: 'conexao:acesso-negado',
  /**
   * Toque de mensagem recebida (ADR 0040). Vai para a sala de cada pessoa que
   * deve ouvir, já decidido no servidor: o dono da conversa, ou quem vê a
   * fila daquele número quando a conversa não tem dono.
   */
  somDeMensagem: 'mensagem:som',
  /** Pedido de apoio para a pessoa chamada: abre o pop-up de aceitar ou recusar (ADR 0043). */
  apoioPedido: 'apoio:pedido',
  /** A resposta ao pedido, para quem pediu e para quem respondeu. */
  apoioRespondido: 'apoio:respondido',
  /** O pedido mudou (cancelado pelo dono, respondido em outra aba): a lista de pendentes recarrega. */
  apoioAtualizado: 'apoio:atualizado',
  /**
   * Mudaram as permissões ou os números da pessoa (mapa de uso, 08/10/2026).
   * A tela dela trava com o aviso de recarregar: até recarregar, ela não
   * continua usando o CRM com o acesso antigo.
   */
  acessoAlterado: 'usuario:acesso-alterado',
  /**
   * A sessão da pessoa caiu no servidor (desativada, senha redefinida). A
   * tela volta para o login na hora, em vez de esperar o próximo clique.
   */
  sessaoEncerrada: 'sessao:encerrada',
  /**
   * Avisos da pessoa saíram sem ela clicar (retorno cancelado, conversa
   * marcada como respondida): o sino e a barra da direita recarregam.
   */
  notificacoesMudaram: 'notificacao:mudaram',
} as const

export type NomeEvento = (typeof EVENTOS)[keyof typeof EVENTOS]

/** Sala por conexão: só quem tem o número liberado recebe o evento. */
export function salaDaConexao(conexaoId: string): string {
  return `conexao:${conexaoId}`
}

export function salaDoUsuario(usuarioId: string): string {
  return `usuario:${usuarioId}`
}
